import React, { useEffect, useRef } from 'react';
import { Chart as ChartJS } from 'chart.js/auto';

const DashboardChart = ({ type = 'doughnut', textTitle, chartData, label,
  backgroundColor = [
    'rgba(255, 99, 132, 0.6)',
    'rgba(54, 162, 235, 0.6)',
    'rgba(255, 206, 86, 0.6)',
    'rgba(75, 192, 192, 0.6)',
    'rgba(153, 102, 255, 0.6)',
  ],
  borderColor = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
  ],
  borderWidth = 1 }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current && chartData.length > 0) {
      const chart = new ChartJS(chartRef.current, {
        type: type,
        data: {
          labels: chartData.map(item => item.label),
          datasets: [
            {
              label: label,
              data: chartData.map(item => item.data),
              backgroundColor: backgroundColor,
              borderColor: borderColor,
              borderWidth: borderWidth,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              display: false,
              outerHeight: '90%'
            },
            title: {
              display: true,
              align: 'center',
              text: textTitle,
            },
            tooltip: {
              enabled: true,
            
             
              bodyFont: {
                size: 12,
              },
              titleColor: '#FFFFFF', // White text for the title
              bodyColor: '#FFFFFF', // White text for the body
              padding: 10,
              cornerRadius: 4,
              displayColors: false, // Hide the color box in the tooltip
              callbacks: {
                // Customize the tooltip label
                label: function (context) {
                  const label = context.dataset.label || '';
                  const value = context.raw;
                  const model = context.label;
                  return `${model} : ${value}`;
                },
                title: function () {
                  return ''; // Remove the default title since we include the label in the body
                },
              },
            },

          },
          ...(type === 'bar' && {
            scales: {
              x: {
                ticks: {
                  display: false,
                },
                grid: {
                  display: false,
                }
              },
            },
          })
        },
      });

      return () => {
        chart.destroy();
      };
    }
  }, [chartData, textTitle, type, label, backgroundColor, borderColor, borderWidth]);

  return (
    <canvas ref={chartRef} style={{ overflow: "hidden" }} />
  )
}

export default DashboardChart;